import {
  createItem,
  deleteItem,
  readItems,
  readRoles,
  updateItem,
} from "@directus/sdk";
import { getDirectusClient } from "../lib/directus";

const directus = getDirectusClient();
export const obtenerCamposUser = async () => {
  try {
    const camposUser = await directus.request(
      readItems("campos_user", {
        fields: ["campo", "opciones", "roles.*", "tipo_campo", "id"],
        limit: 25,
      })
    );

    // Obtener los roles asociados a cada campo_user
    const rolesPorCampo = await Promise.all(
      camposUser.map(async (campo) => {
        const roles = await directus.request(
          readItems("campos_user_directus_roles", {
            fields: [
              "id",
              "directus_roles_id.id",
              "directus_roles_id.name",
              "directus_roles_id",
            ],
            filter: {
              campos_user_id: {
                _eq: campo.id,
              },
            },
          })
        );
        return {
          ...campo,
          roles,
        };
      })
    );

    return rolesPorCampo;
  } catch (error) {
    throw error;
  }
};

export const crearValoresCampo = async (campoData) => {
  try {
    const response = await directus.request(
      createItem("valores_campos_user", {
        ...campoData,
      })
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const ObtenerValoresCampo = async () => {
  try {
    const response = await directus.request(
      readItems("valores_campos_user", {
        fields: ["campos_users", "id", "valor", "user"],
        limit: 25,
      })
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const EliminarCampos = async (campoId) => {
  try {
    await directus.request(deleteItem("campos_user", campoId));
    return true;
  } catch (error) {
    throw error;
  }
};
export const Eliminarvalorescampos = async (valorId) => {
  try {
    await directus.request(deleteItem("valores_campos_user", valorId));
    return true;
  } catch (error) {
    throw error;
  }
};
export const EditCampousers = async (campoId, payload) => {
  try {
    const response = await directus.request(
      updateItem("campos_user", campoId, payload)
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const AllRoles = async () => {
  try {
    const response = await directus.request(
      readRoles({
        fields: ["id", "name"],
        filter: {
          name: {
            _nin: ["Administrator", "adminapp"],
          },
        },
      })
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const CrearCampos = async (payload) => {
  try {
    const response = await directus.request(
      createItem("campos_user", {
        ...payload,
      })
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const EditValorCampousers = async (valorId, payload) => {
  try {
    const response = await directus.request(
      updateItem("valores_campos_user", valorId, payload)
    );
    return response;
  } catch (error) {
    throw error;
  }
};
